import React, { FunctionComponent } from 'react'
import { Timestamps } from '../../service/Timestamps'
import { ChatbotSparklesIcon, LightbulbIcon } from '../Icons/Icons'
import { AiIconGradient } from './AiIconGradient'
import styles from './KeyInsights.module.css'

interface Props {
  insights: string[]
  createdAt?: string
}

// KeyInsights renders the customer-facing insights from the health check
export const KeyInsights: FunctionComponent<Props> = ({ insights, createdAt }) => (
  <div data-testid='key-insights' className={styles.sectionWrapper}>
    <div className={styles.headerRow}>
      <figure className='angular'>
        {/* the three stars mark AI-written content, as on Mission Control */}
        <i className='icon thirtytwo flex-noshrink'>
          <ChatbotSparklesIcon />
        </i>
      </figure>
      <h4>Key insights and suggestions</h4>
    </div>

    {/* the lightbulbs take the AI gradient: these are AI-written */}
    <AiIconGradient />

    {insights.length > 0 ? (
      <ul className={styles.insightsList}>
        {insights.map((insight, index) => (
          <li key={index}>
            <i className='icon sixteen outline'>
              <LightbulbIcon />
            </i>
            {insight}
          </li>
        ))}
      </ul>
    ) : (
      <p className='blk subdued no-margin-bottom'>No insights available.</p>
    )}

    {createdAt && (
      <small className={`blk subdued no-margin-bottom ${styles.createdAt}`}>
        Created at {Timestamps.format(new Date(createdAt))}
      </small>
    )}
  </div>
)
